import { useCallback, useEffect, useState } from "react"

type DialogBaseProps = {
    title: string
    message: string
    submitButtonText: string
    closeButtonText?: string
}

type UseDialogConfirmationParams = {
    open: boolean
    baseDialogProps: DialogBaseProps
    confirmationDialogProps: DialogBaseProps
    onSubmit: VoidFunction
    onClose: VoidFunction
}

export const useDialogConfirmation = ({
    open,
    onClose,
    onSubmit,
    baseDialogProps,
    confirmationDialogProps,
}: UseDialogConfirmationParams) => {
    const [isOpenConfirmDialog, setIsOpenConfirmDialog] = useState(false)

    const handleSubmit = useCallback(() => {
        if (!isOpenConfirmDialog) {
            setIsOpenConfirmDialog(true)
        } else {
            onSubmit?.()
        }
    }, [isOpenConfirmDialog, onSubmit])

    const handleClose = useCallback(() => {
        setIsOpenConfirmDialog(false)
        onClose?.()
    }, [onClose])


    const dialogProps = isOpenConfirmDialog ? confirmationDialogProps : baseDialogProps

    return {
        isOpen: open || isOpenConfirmDialog, 
        dialogProps,
        close: handleClose,
        submit: handleSubmit,
    }
}